import { useLive } from '@/lib/live';
import { cn, formatDateTime } from '@/lib/utils';

/** "Live" dot in the header: green when connected, ripples each time someone else saves something. */
export function LiveIndicator() {
  const { connected, pulse, last } = useLive();
  return (
    <span
      className="hidden items-center gap-1.5 rounded-full border border-border bg-surface px-2.5 py-1 text-[11px] font-semibold text-fg-muted lg:inline-flex"
      title={connected ? (last ? `Live — last change by ${last.actor ?? 'someone'} at ${formatDateTime(last.at)}` : 'Live — screens update as others save') : 'Reconnecting…'}
    >
      <span className="relative flex size-2">
        <span key={pulse} className={cn('absolute inline-flex size-full rounded-full', connected ? 'fx-ping bg-success' : 'bg-warning')} />
        <span className={cn('relative inline-flex size-2 rounded-full', connected ? 'bg-success' : 'bg-warning')} />
      </span>
      {connected ? 'Live' : 'Offline'}
    </span>
  );
}
